module.exports = __webpack_public_path__ + "static/media/list-ol.a9e79322.svg";